import * as actionTypes from "./action-types";
import * as LOCALSTORAGE from "../../constants/LocalStorage";
import { getStorage, setStorage, removeStorage, mergeDataToStorage } from "../../services/StorageService";
import { sendPostRequest } from "../../services/FetchService.js";
import * as API_PATHS from "../../constants/FetchApi.js";
import { sentryReportEvent } from "../../services/SentryReportService";

export const commitCreambowBuyFormData = (data) => {
  return async function (dispatch) {
    setStorage(LOCALSTORAGE.creambowQuestionnaire, data);
    dispatch({
      type: actionTypes.COMMIT_PURCHASE_FORM_DATA,
      payload: data,
    });
  };
};

export const creambowValidateDiscountCode = (discountCode) => {
  return async function (dispatch) {
    dispatch({ type: actionTypes.VALIDATE_DISCOUNT_CODE });
    try {
      const discountCodeResponse = await sendPostRequest(API_PATHS.FORIO_VALIDATE_DISCOUNT_CODE, discountCode);
      if (!discountCodeResponse.data?.payload?.validDiscountCode) {
        dispatch({ type: actionTypes.VALIDATE_DISCOUNT_CODE_FAILED, payload: discountCodeResponse.data.message });
        return;
      }
      const payload = {
        discountCode: discountCodeResponse.data.payload.discountCode,
        discountedPrice: discountCodeResponse.data.payload.discountedPrice,
      };
      mergeDataToStorage(LOCALSTORAGE.creambowQuestionnaire, payload);

      if (discountCodeResponse.data?.payload?.paymentSummaryId) {
        payload.paymentSummaryId = discountCodeResponse.data.payload.paymentSummaryId;
        mergeDataToStorage(LOCALSTORAGE.creambowQuestionnaire, {
          paymentSummaryId: discountCodeResponse.data.payload.paymentSummaryId,
        });
        dispatch({ type: actionTypes.VALIDATE_DISCOUNT_CODE_PAYMENT_SUCCESS, payload: payload });
        return;
      }

      dispatch({ type: actionTypes.VALIDATE_DISCOUNT_CODE_SUCCESS, payload: payload });
    } catch (err) {
      const sentryTag = {
        name: "CreambowDiscountCodeFailed",
        data: discountCode,
      };
      sentryReportEvent(err, sentryTag);
      dispatch({ type: actionTypes.VALIDATE_DISCOUNT_CODE_FAILED, payload: err });
    }
  };
};

export const creambowResetDiscountCode = () => {
  return async function (dispatch) {
    dispatch({ type: actionTypes.VALIDATE_DISCOUNT_CODE_RESET });
  };
};

export const restoreCreambowPurchaseInformationFromStorage = () => {
  return async function (dispatch) {
    const cachedQuestionnaireInformation = getStorage(LOCALSTORAGE.creambowQuestionnaire);
    if (cachedQuestionnaireInformation) {
      dispatch({
        type: actionTypes.RESTORE_STORAGE_PURCHASE_INFORMATION,
        payload: cachedQuestionnaireInformation,
      });
    }
    return true;
  };
};

export const updateTransactionCreambowData = (transactionData) => {
  return async function (dispatch) {
    dispatch({ type: actionTypes.UPDATE_TRANSACTION_DATA, payload: transactionData });
  };
};

export const creambowCreateSimulation = (createSimulationRequest) => {
  return async function (dispatch) {
    dispatch({ type: actionTypes.CREATE_SIMULATION_REQUEST_START });
    try {
      const response = await sendPostRequest(API_PATHS.FORIO_CREATE_SIMULATION, createSimulationRequest);
      if (!response.data.outcome) {
        dispatch({ type: actionTypes.CREATE_SIMULATION_REQUEST_FAIL, payload: response.data.message });
        return;
      }
      dispatch({ type: actionTypes.CREATE_SIMULATION_REQUEST_SUCCESS, payload: response.data.payload });
    } catch (err) {
      dispatch({ type: actionTypes.CREATE_SIMULATION_REQUEST_FAIL, payload: err });
    }
  };
};

export const resetCreateSimulationDefaults = () => {
  return { type: actionTypes.RESET_CREATE_SIMULATION_DEFAULTS };
};

export const resetCreambowBuySimulationStoreDefaults = () => {
  removeStorage(LOCALSTORAGE.creambowQuestionnaire);
  return {
    type: actionTypes.RESET_CREAMBOW_BUY_SIMULATION_DEFAULTS,
  };
};
